import { useContext } from 'react';

import { InterfaceSettingsContext, InterfaceSettingsModel } from './context';

export function useInterfaceSettings(): InterfaceSettingsModel {
  return useContext(InterfaceSettingsContext);
}

export default useInterfaceSettings;
